import { ref, computed } from 'vue'
import { getBackendClient, unwrapApiResponse, type ApiSchema } from '~/api/client'
import { useEffectiveCustomerId } from '~/composables/useEffectiveCustomerId'
import { mapAgent, type Agent } from '~/api/mappers'
import { useImpersonateStore } from '~/stores/impersonate'

const agentId = ref<string | null>(null)
const agents = ref<Agent[] | null>(null)

const fetchAgents = async () => {
  const impersonateStore = useImpersonateStore()
  if (impersonateStore.isImpersonating && !impersonateStore.impersonatedCustomerId) {
    await impersonateStore.fetchContext()
  }
  const effectiveCustomerId = useEffectiveCustomerId()
  const apiClient = getBackendClient()

  try {
    const response: ApiSchema<'GetAgent'>[] = await unwrapApiResponse(
      apiClient.GET('/agents', {
        params: {
          query: {
            customer_id: effectiveCustomerId.value || undefined,
          },
        },
      }),
    )
    agents.value = response.map(mapAgent)
  }
  catch (error) {
    $logError('Error fetching agents:', error)
  }
}

const agent = computed(() =>
  agents.value ? agents.value.find(a => a.id === agentId.value) : null,
)

const useAgent = () => {
  const setAgentId = (id: string) => {
    agentId.value = id
  }

  const loadAgents = async () => {
    await fetchAgents()
  }

  const setAgentName = (newName: string, agentId: string) => {
    agents.value?.forEach((item) => {
      if (item.id === agentId) {
        item.name = newName
      }
    })
  }

  return { agent, agents, setAgentName, setAgentId, loadAgents }
}

export default useAgent
